import { render, staticRenderFns } from "./CardQuiz.vue?vue&type=template&id=7ebd9782&scoped=true&"
import script from "./CardQuiz.vue?vue&type=script&lang=js&"
export * from "./CardQuiz.vue?vue&type=script&lang=js&"
import style0 from "./CardQuiz.vue?vue&type=style&index=0&id=7ebd9782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebd9782",
  null
  
)

export default component.exports